<template>
<div>
    <p class="mt-2">Enter your card details to pay</p>

    <div class="modal-body">
        <form class="form" ref="cardForm" @submit.prevent="collectPin">

            <div class="row mx-0">
                <div class="col-12 px-0">
                    <div class="form-group" ref="cardFormGroup">
                        <label for="card_cc">Card Number</label>
                        <the-mask :mask="['#### #### #### #### ###']" v-model="card_cc" id="card_cc" ref="card_cc" class="card_number cc-masked form-control " placeholder="0000 0000 0000 0000 000" title="Enter your card number" data-exception="cc" data-valid-example="5063 5232 3523 2533 234" required autofocus @focus.native="card_cc_hover = true" @blur.native="card_cc_hover = false" :style="{ borderColor: (card_cc_hover ? ccBorderColor : borderColor)  }" />
                        <span class="invalid-feedback" :style="(errors.card_cc) ? 'display : inline' : ''">Invalid card number</span>
                    </div>
                </div>
            </div>

            <div class="row m-0 mb-2">
                <div class="col-sm-4 col-4">
                    <div class="form-group" ref="expiryFormGroup" style="margin-right:5px">
                        <label for="card_exp_month">Month</label>
                        <the-mask :mask="['##']" v-model="card_exp_month" id="card_exp_month" ref="card_exp_month" class="form-control" placeholder="MM" required @focus.native="card_exp_month_hover = true" max-length="2" @blur.native="card_exp_month_hover = false" :style="{ borderColor: (card_exp_month_hover ? expMonthBorderColor : borderColor)  }"  />
                        <span class="invalid-feedback" :style="(errors.card_exp_month) ? 'display : inline' : ''">Invalid expiry month</span>
                    </div>
                </div>

                <div class="col-sm-4 col-4 px-0">
                    <div class="form-group" ref="expiryFormGroup" style="margin-right:5px">
                        <label for="card_exp_year">Year</label>
                        <the-mask :mask="['##']" v-model="card_exp_year" id="card_exp_year" ref="card_exp_year" class="form-control" placeholder="YY" required @focus.native="card_exp_year_hover = true" max-length="2" @blur.native="card_exp_year_hover = false" :style="{ borderColor: (card_exp_year_hover ? expYearBorderColor : borderColor)  }"  />
                        <span class="invalid-feedback" :style="(errors.card_exp_year) ? 'display : inline' : ''">Invalid expiry year</span>
                    </div>
                </div>

                <div class="col-sm-4 col-4 px-0">
                    <div class="form-group" ref="cvvFromGroup">
                        <label for="card_cvv">CVV</label>
                        <the-mask :mask="['###']" v-model="card_cvv" id="card_cvv" ref="card_cvv" class="form-control" placeholder="123" required="" title="Enter your card cvv" @focus.native="card_cvv_hover = true" max-length="3" @blur.native="card_cvv_hover = false" :style="{ borderColor : (card_cvv_hover ? cvvBorderColor : borderColor) }"  />
                        <span class="invalid-feedback" :style="(errors.card_cvv) ? 'display : inline' : ''">Invalid card CVV</span>
                    </div>
                </div>
            </div>

            <div class="row m-0 ">
                <div class="col-12 px-0">
                    <div class="form-group mb-0">
                        <button type="submit" class="btn app-bg-color" :style="button_color" ref="btnActionPay" id="btnActionPay">Continue</button>
                    </div>
                </div>
            </div>
        </form>
    </div>

</div>
</template>

<script>
import {
    TheMask
} from 'vue-the-mask'
import {
    EventBus
} from '../includes/bus.js'; // Masterpass, verve, visa

export default {
    props: {
        button_color: {
            type:Object,
            required:true,
        }

    },
    components: {
        TheMask,
    },
    watch: {
        card_cc_hover(newVal) {
            if (newVal)
                this.ccBorderColor = this.appColor;
        },
        card_exp_hover(newVal) {
            if (newVal)
                this.expBorderColor = this.appColor;
        },
        card_exp_month_hover(newVal) {
            if (newVal)
                this.expMonthBorderColor = this.appColor;
        },
        card_exp_year_hover(newVal) {
            if (newVal)
                this.expYearBorderColor = this.appColor;
        },
        card_cvv_hover(newVal) {
            if (newVal)
                this.cvvBorderColor = this.appColor;
        },
        isVerve(val) {
            this.isVerve = val;
        },
        card_cc(val) {

            if (['0', '1', '2', '6', '7', '8', '9'].includes(val.substring(0, 1))) {
                this.errors.card_cc = true;
            } else {
                this.errors.card_cc = false;
                setTimeout(() => {
                    this.isVerve = false;
                    if (val.length >= 16) {
                        this.setCardType(val)
                    }
                }, 200);
            }
        },
        card_exp_month(val) {
            if (this.$refs.card_exp_month) {
                this.$refs.card_exp_month.$el.className += "appColor";
            }

            if (this.$refs.card_cvv && val.length == 2) {
                this.$refs.card_exp_year.$el.focus();
            }
        },
        card_exp_year(val) {
            if (this.$refs.card_exp_year ) {
                this.$refs.card_exp_year.$el.className += "appColor";
            }

            if (this.$refs.card_cvv && val.length == 2) {
                this.$refs.card_cvv.$el.focus();
            }
        },
    },
    data() {
        return {
            card_cc: '',
            card_exp: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvv: '',
            borderColor: '#e4e4e4',
            ccBorderColor: '',
            expBorderColor: '',
            expMonthBorderColor: '',
            expYearBorderColor: '',
            cvvBorderColor: '',
            card_cc_hover: true,
            card_exp_year_hover: false,
            card_exp_month_hover: false,
            card_exp_hover: false,
            card_cvv_hover: false,
            isVerve: false,
            removeMargin: false,
            errors: {
                card_cc: false,
                card_exp: false,
                card_exp_month: false,
                card_exp_year: false,
                card_cvv: false,
            },
        }
    },

    mounted() {
        if (!this.isLoading) {
            this.ccBorderColor = this.appColor;

            if (document.getElementById('card_cc'))
                document.getElementById('card_cc').focus();
        }
    },
    methods: {
        setCardType(val) {
            this.isVerve = false;
            if (['50', '65'].includes(val.substring(0, 2)))
                this.isVerve = true;
        },

        cardExpHasError() {
            var exMonth = this.card_exp_month,
                exYear = "20" + this.card_exp_year,
                today = new Date(),
                someday = new Date();
            someday.setFullYear(exYear, parseInt(exMonth), 1);

            if (this.card_exp_month.length !== 2 || someday < today || exMonth > 12) {
                this.errors.card_exp_year = this.errors.card_exp_month = true;
                return true;
            }

            this.errors.card_exp_year = this.errors.card_exp_month = false;

            this.card_exp = `${this.card_exp_month}${this.card_exp_year}`
            return false;
        },

        cardCcHasError() {
            if ((this.isVerve && this.card_cc.length > 16) || (!this.isVerve && this.card_cc.length >= 16)) {
                return false;
            } else {
                this.errors.card_cc = true;
                return true;
            }
        },

        cardCvvhasError() {
            return this.card_cvv.length < 3 ? true : false;
        },

        showValidationErrors() {
            this.errors.card_cvv = false;
            this.errors.card_cc = false;
            this.errors.card_exp_month = false;
            this.errors.card_exp_year = false;

            if (this.cardCvvhasError()) {
                this.errors.card_cvv = true;
            }

            if (this.cardCcHasError()) {
                this.errors.card_cc = true;
            }

            if (this.cardExpHasError()) {
                this.errors.card_exp_month = true;
            }

            return this.errors.card_exp_month || this.errors.card_exp_year || this.errors.card_cc || this.errors.card_cvv;
        },
        collectPin() {
            if (this.showValidationErrors())
                return;

            this.$store.dispatch('card_cc', this.card_cc.toString().replace(/ /g, ''));
            this.$store.dispatch('card_exp', this.card_exp);
            this.$store.dispatch('card_cvv', this.card_cvv);
            EventBus.$emit('changeComponent', 'Pin');

        },
    },
}
</script>
